import { useHistory } from "react-router-dom";
import { Box, Button } from "@mui/material"
import { ArrowLeftIcons } from "../../../../../core/global/Icons"
import {CutoffUpdate } from "../../../global/API";
import { useContext } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
export const Bottom = (props) => {
    const { loc, user_id, __SESSION,  submitFormLoader, setSubmitFormLoader, cutoffForm} = props
    let nav = useHistory()
    const {global_component_state} = useContext(ToolContext)
    const {snackBarLoader} = global_component_state

    const backHandler = () => {
        nav.push('/setup/cutoff/list')
    }

    const submitHandler = async() => {
        const hour = cutoffForm.cutoff_time.hour();
        const minute = cutoffForm.cutoff_time.minute();

        if(hour === "" || minute === ""){
            snackBarLoader.set({snackbar:true, msg:'Invalid Time', type: "error"})
            return
        }

        let body = {
            company_id: __SESSION.data.uaccess[0].company_id,
            user_id: user_id,
            cutoff_time: String(hour+":"+minute)
        }
        setSubmitFormLoader((prev) => ({...prev, loader:true}))
        let res = await CutoffUpdate(body)
        if (res === "success"){
            snackBarLoader.set({snackbar:true, msg:'Successfully Saved', type: "success"})
            setSubmitFormLoader((prev) => ({...prev, loader:false}))
            nav.push('/setup/cutoff/list') 
        }
    }

    return (
        <Box minHeight="80px" display="flex" alignItems="center" justifyContent="flex-end" gap={2}>
            <Box onClick={backHandler} component={Button} minHeight="50px" minWidth="120px" borderRadius={3} display="flex" alignItems="center" justifyContent="center" bgcolor="#fff" color="#00000061" sx={{border:"1px solid #EBEBEB"}} startIcon={<ArrowLeftIcons stroke="#00000061"/>} px={3}>
                <Box fontSize={14} fontWeight={400} lineHeight="19px">Back</Box>
            </Box>
            <Box id="walkthrough-branch-step-4" disabled={submitFormLoader.loader}  onClick={submitHandler} component={Button} minHeight="50px" minWidth="120px" borderRadius={3} display="flex" alignItems="center" justifyContent="center" sx={{bgcolor: "primary.main", color: "#fff",border:"1px solid #EBEBEB", ":hover": {bgcolor: "primary.main"}}} px={3}>
                <Box fontSize={14} fontWeight={400} lineHeight="19px">{loc === 'create' ? 'Save' : 'Update'}</Box>
            </Box>
        </Box>
    )
}